const {JettonMinter} = require("./JettonMinter.js");
const {JettonWallet} = require("./JettonWallet.js");

module.exports.default = {
    JettonMinter,
    JettonWallet
};